import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import Button from '../../Button/Button';
import ButtonTypes from '../../../constants/buttonTypes';
import { IconCalendar } from '../../../assets/icon';

const CustomDateInput = forwardRef(({ value, onClick, placeholderText }, ref) => {
  return (
    <Button
      icon={<IconCalendar />}
      type={ButtonTypes.LIGHT}
      text={value || placeholderText}
      onClick={onClick}
      innerRef={ref}
      containerStyle="py-[9px] px-[13px] justify-start"
    />
  );
});

CustomDateInput.propTypes = {
  value: PropTypes.string,
  placeholderText: PropTypes.string,
  onClick: PropTypes.func
};

CustomDateInput.defaultProps = {
  onClick: () => {},
  value: '',
  placeholderText: 'Select date',
};

export default CustomDateInput;
